import React, { useEffect, useState, useRef } from 'react';

import moment from 'moment';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import { TbDatabaseExclamation } from 'react-icons/tb';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import { Skeleton } from '@mui/material';
import { FaSearch } from 'react-icons/fa';
import useIsMobile from 'utils/isMobileUtils';
import StatusBadge from 'ui-component/StatusBadge';
import { getCurrencySymbolV2, numberFormatter } from 'utils/currency';

// ✅ Clear
const PurchaseOrderTab = ({ productDetails }) => {

    const [isLoading, setIsLoading] = useState(true);

    const [searchField, setSearchField] = useState();
    const [searchValue, setSearchValue] = useState();
    const isMobile = useIsMobile();

    /*
    * Start Infinite Scroll
    * ---------------------
    */
    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const tableRef = useRef();
    const [showPreloadingRows, setShowPreloadingRows] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchTimeout, setSearchTimeout] = useState(null);

    const initializeData = () => {

        let request = {}
        request.page = 1;
        request.search = searchField?.length > 2 ? searchField : null;

        api.getProductPurchaseOrders(productDetails?.id, request, searchField).then((res) => {
            setDataList([]);
            setTimeout(() => {
                setDataList(res?.data?.data?.data || []);

                setHasMore(true);
                setPage(1);
                // dispatch(setLoading(false));
                setIsLoading(false);
                // setIsFirstLoad(false);
                setShowPreloadingRows(false);
                setTotalRecords(res?.data?.data?.total || 0);
            }, 300);
        });
    }


    useEffect(() => {
        // Only run fetchData after user stops typing (debounced by searchTimeout)
        // setIsLoading(true);
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        const timeout = setTimeout(() => {
            const fetchData = async () => {
                setDataList([]);
                initializeData();
                // getFiltersList();
            };
            fetchData();
        }, 500); // 500ms debounce

        setSearchTimeout(timeout);

        // Cleanup on unmount or before next effect run
        return () => clearTimeout(timeout);
        // Only trigger when these change
    }, [searchField]);


    useEffect(() => {
        const handleScroll = () => {
            if (!tableRef.current || showPreloadingRows || !hasMore) return;
            const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
            // Trigger only when user reaches the bottom (with a small threshold)
            if (scrollTop + clientHeight >= scrollHeight - 10) {
                loadMoreData();
            }
        };
        const currentRef = tableRef.current;
        if (currentRef) {
            currentRef.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (currentRef) {
                currentRef.removeEventListener('scroll', handleScroll);
            }
        };
    }, [showPreloadingRows, hasMore, dataList]);


    const loadMoreData = () => {
        if (showPreloadingRows || !hasMore) return;
        setShowPreloadingRows(true);
        let request = {};
        request.page = page + 1;
        request.search = searchField?.length > 2 ? searchField : null;

        
        api.getProductPicklistsList(productDetails?.id, request, searchField).then((res) => {
            // Use pagination meta from backend
            const nextPage = res?.data?.data?.meta?.current_page || request.page;
            const lastPage = res?.data?.data?.meta?.last_page || nextPage;
            if (nextPage > lastPage || res?.data?.data?.data?.length === 0) {
                setHasMore(false);
            } else {
                setDataList(prev => [...prev, ...res?.data?.data?.data || []]);
                setPage(nextPage);
            }
            setShowPreloadingRows(false);
        });
    };

    /*
    * End Infinite Scroll
    * ---------------------
    */


    const handleSearch = (e) => {
        let text = e.target.value;
        
        setIsLoading(true);
        setSearchValue(text);
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        // Only update searchField after user stops typing for 500ms
        let timeout = setTimeout(() => {
            // dispatch(storeSearchInvoice(text));
            setSearchField(text)	
        }, 500);

        setSearchTimeout(timeout);

    };


    if (!isMobile) {

        return (
            <div className="content mt15">
                <div className="row">
                    <div className="col-12 " style={{ marginBottom: '-10px' }}>
                        <div
                            className=" align-items-center justify-content-between TableSerachBar"
                            style={{ 
                                position: 'absolute',
                                zIndex: 3,
                                marginTop: '-63px',
                                right: 0,
                            }}
                        >
                            <div>
                            </div>
                            <form className="form-inline navbar-search" style={{ display: 'flex', gap: '5px' }} onSubmit={(e) => e.preventDefault()}>
                        
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control bg-white border"
                                        placeholder="Search"
                                        aria-label="Search"
                                        aria-describedby="basic-addon2"
                                        value={searchValue || ''}
                                        onChange={handleSearch}
                                        style={{ width: '100%' }}
                                    />
                                    <span className="searchIcon">
                                        <FaSearch />
                                    </span>
                                </div>
                            </form>
                        </div>
                        <div
                            className="table-responsive-xl tableData estimationList"
                            ref={tableRef}
                            style={{
                                height: 'calc(100vh - 390px)',
                                overflowY: 'auto',
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#0966ff transparent'

                            }}
                        >
                            <table className="table  min-width-unset tbl-space pm-table d-none d-md-table">
                                <thead>
                                    <tr className="sticky-header ">
                                        <th scope="col" className="font14" style={{ width: '180px' }}>Purchase Invoice #</th>
                                        <th scope="col" className="font14" width="">Supplier</th>
                                        <th scope="col" style={{ width: '120px' }} className="font14">Color</th>
                                        <th scope="col" style={{ width: '100px' }} className="font14 text-center">QTY</th>
                                        <th scope="col" style={{ width: '120px' }} className="font14">Unit Price</th>
                                        <th scope="col" className="font14" style={{ width: '120px' }}>Status</th>
                                        <th scope="col" style={{ width: '122px' }}>Purchased Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        isLoading ? (
                                            [...Array(25)].map((e, i) => (
                                                <tr style={{ height: '35px' }} key={i}>
                                                    {[...Array(7)].map((e, i) => (
                                                        <td>
                                                            <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))
                                        ) : (
                                            dataList?.length > 0 ? ( 
                                                <>
                                                    {dataList?.map((row, index) => {
                                                        return (
                                                            <tr key={index} style={{ height: '40px' }}>
                                                                <td className="align-middle font14">

                                                                    <a href={`/purchasing/view/${row?.purchase_invoice_id}`} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                                                        {row?.reference_no}
                                                                    </a>
                                                                </td>
                                                                <td className="align-middle font14">
                                                                    
                                                                    {
                                                                        row?.supplier?.name ? (
                                                                            <a href={`/contacts/${row?.supplier?.id}`} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                                                                <PrivacyModeContent>{row?.supplier?.name}</PrivacyModeContent>
                                                                            </a>
                                                                        ) : (
                                                                            <span className="text-gray-600">---</span>
                                                                        )
                                                                    }
                                                                    
                                                                </td>
                                                                <td className="align-middle font14">
                                                                    {
                                                                        row?.color ? (
                                                                            row?.color
                                                                        ) : (
                                                                            <span className="text-gray-500">Not mentioned</span>
                                                                        )
                                                                    }
                                                                </td>
                                                                <td className="align-middle font14 text-center">{row?.quantity}</td>
                                                                <td className="align-middle font14 ">
                                                                    <div className="flex gap-1">
                                                                        <div style={{ marginTop: `${row?.currency === 'aed' ? '-1px' : '0' }`}}>
                                                                            {getCurrencySymbolV2(row?.currency, row?.currency, '11px', '11px')}
                                                                        </div>
                                                                        <div>
                                                                            {row?.unit_price ? numberFormatter.format(row?.unit_price) : 'N/A'}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="align-middle font14">
                                                                    <StatusBadge itemStatus={row?.status} />
                                                                </td>
                                                                <td className="align-middle font14">
                                                                    {moment(row?.purchased_date).format(CommonDateOnlyFormat)}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                        
                                                    {showPreloadingRows && (
                                                        [...Array(100)].map((e, i) => (
                                                            <tr key={i} style={{ height: '40px' }}>
                                                                {[...Array(7)].map((e, i) => (
                                                                    <td>
                                                                        <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        ))
                                                    )}
                                                </>
                                            ): (
                                                <tr>
                                                    <td colSpan={7}>
                                                    
                                                        <div className="not-found-container" style={{ height: '20vh' }}>
                                                            <div className="not-found-icon">
                                                                <TbDatabaseExclamation />
                                                            </div>
                                                            <h6 className="not-found-text">No Data Available</h6>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )	
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div
                            className="hide-on-mobile"
                            style={{
                                padding: '10px 0 0 20px',
                                borderTop: '1px solid #e0e0e0e0',
                                display: 'flex',
                                gap: '5px',
                                justifyContent: 'space-between',
                                height: '40px',
                            }}
                        >

                            <div className="flex align-items-center" style={{ gap: '10px' }}>
                            </div>
                            <div className="flex align-items-center ml-auto" style={{ gap: '5px', paddingRight: '25px' }}>
                                {isLoading ? (
                                    <div style={{ width: '100px' }}>
                                        <Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
                                    </div>
                                ) : (
                                    <>
                                        <div className="text-gray-800">Total Record:</div>
                                        <div className="fw-500">
                                                {totalRecords.toLocaleString('en-US')}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {

        return (
            <div className="content mt15">
                <div className="row">
                    <div className="col-12 " style={{ marginBottom: '-10px' }}>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 10,
                            }}
                            className="show-on-mobile"
                        >
                            <form className="form-inline navbar-search" style={{ flex: 1 }}>
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                        type="text"
                                        className="form-control bg-white border"
                                        placeholder="Search"
                                        aria-label="Search"
                                        aria-describedby="basic-addon2"
                                        value={searchValue || ''}
                                        onChange={handleSearch}
                                        style={{ width: '100%', paddingRight: 36 }}
                                    />
                                    <span
                                        className="searchIcon"
                                        style={{
                                            position: 'absolute',
                                            right: 10,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            color: '#888',
                                            pointerEvents: 'none'
                                        }}
                                    >
                                        <FaSearch />
                                    </span>
                                </div>
                            </form>
                        </div>


                        <div
                            className="table-responsive-xl tableData estimationList"
                            ref={tableRef}
                            style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                                        
                            <div
                                className="inv-cards-list d-md-none"
                                style={{
                                    padding: '12px 0',
                                    height: `calc(100dvh - 550px)`,
                                    overflowY: 'auto',
                                    marginTop: '10px',
                                    scrollbarWidth: 'thin',
                                    scrollbarColor: '#0966ff transparent'
                                }}
                            >                          
                                {isLoading ? (
                                    [...Array(15)].map((_, idx) => (
                                        <div
                                            key={idx}
                                            className="order-list-card"
                                            style={{
                                                background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
                                                marginBottom: 10,
                                                borderRadius: 12,
                                                padding: 16,
                                                minHeight: 90,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                // gap: 10
                                            }}
                                        >
                                            {[...Array(3)].map((__, i) => (
                                                <div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
                                                    <Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
                                                </div>
                                            ))}
                                        </div>
                                    ))
                                ) : (
                                    <>
                                        {dataList?.map((item, index) => (
                                            
                                            <div
                                                key={index}
                                                className="order-list-card"
                                                style={{
                                                    background: '#fff',
                                                    marginBottom: 10,
                                                    borderRadius: 12,
                                                    padding: 16,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                <div className="row">
                                                    <div className="col-12 flex gap-2 align-items-center">
                                                        <div className="font14 fw-500">Purchase Invoice </div>
                                                        <div className="font14 text-gray-700" style={{ marginLeft: '10px' }}>

                                                            <a href={`/purchasing/view/${item?.purchase_invoice_id}`} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                                                {item?.reference_no}
                                                            </a>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 flex gap-2 align-items-center">
                                                        <div className="font14 fw-500">Supplier </div>
                                                        <div className="font14 text-gray-700" style={{ marginLeft: '65px' }}>

                                                            {
                                                                item?.supplier?.name ? (
                                                                    <a href={`/contacts/${item?.supplier?.id}`} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                                                        <PrivacyModeContent>{item?.supplier?.name}</PrivacyModeContent>
                                                                    </a>
                                                                ) : (
                                                                    <span className="text-gray-600">---</span>
                                                                )
                                                            }
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 flex gap-2 align-items-center">
                                                        <div className="font14 fw-500">Color </div>
                                                        <div className="font14 text-gray-700" style={{ marginLeft: '83px' }}>

                                                            {
                                                                item?.color ? (
                                                                    item?.color
                                                                ) : (
                                                                    <span className="text-gray-500">Not mentioned</span>
                                                                )
                                                            }
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 flex gap-2 align-items-center">
                                                        <div className="font14 fw-500">QTY </div>
                                                        <div className="font14 text-gray-700" style={{ marginLeft: '91px' }}>

                                                            {item?.quantity} pcs
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 flex gap-2 align-items-center">
                                                        <div className="font14 fw-500">Unit Price </div>
                                                        <div className="font14 text-gray-700" style={{ marginLeft: '58px' }}>
                                                            <div className="flex gap-1">
                                                                <div style={{ marginTop: `${item?.currency === 'aed' ? '-1px' : '0' }`}}>
                                                                    {getCurrencySymbolV2(item?.currency, item?.currency, '11px', '11px')}
                                                                </div>
                                                                <div>
                                                                    {item?.unit_price ? numberFormatter.format(item?.unit_price) : 'N/A'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 flex gap-2 align-items-center">
                                                        <div className="font14 fw-500">Status </div>
                                                        <div className="font14 text-gray-700" style={{ marginLeft: '75px' }}>
                                                            <div style={{ width: '110px' }}>

                                                                <StatusBadge itemStatus={item?.status} />
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 flex gap-2 align-items-center">
                                                        <div className="font14 fw-500">Date Purchased </div>
                                                        <div className="font14 text-gray-700" style={{ marginLeft: '15px' }}>
                                                            <div style={{ width: '120px' }}>

                                                                {moment(item?.purchased_date).format(CommonDateOnlyFormat)}
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        ))}
                                        
                                        
                                        {showPreloadingRows && (
                                            [...Array(100)].map((_, idx) => (
                                                <div
                                                    key={idx}
                                                    className="order-list-card"
                                                    style={{
                                                        background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
                                                        marginBottom: 10,
                                                        borderRadius: 12,
                                                        padding: 16,
                                                        minHeight: 90,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: 10
                                                    }}
                                                >
                                                    {[...Array(3)].map((__, i) => (
                                                        <div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
                                                            <Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
                                                        </div>
                                                    ))}
                                                </div>
                                            ))
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                        


                        <div
                            className="hide-on-mobile"
                            style={{
                                padding: '10px 0 0 20px',
                                display: 'flex',
                                gap: '5px',
                                justifyContent: 'space-between',
                                height: '40px',
                            }}
                        >

                            <div className="flex align-items-center" style={{ gap: '10px' }}>
                            </div>
                            <div className="flex align-items-center ml-auto" style={{ gap: '5px', paddingRight: '25px' }}>
                                {isLoading ? (
                                    <div style={{ width: '100px' }}>
                                        <Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
                                    </div>
                                ) : (
                                    <>
                                        <div className="text-gray-800">Total Record:</div>
                                        <div className="fw-500">
                                                {totalRecords.toLocaleString('en-US')}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default PurchaseOrderTab;
